import { useGetProceduresQuery, useSetUserDepartment } from 'lib/apollo/hooks'
import { loadNotifications } from 'lib/utils/loadNotifications'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  useDateRange,
  useEnterpriseStore,
  useNotificationActions,
  useRoomViewStore,
} from 'store'

export const useDepartmentSelectorLogic = () => {
  const {
    departments,
    selectedDepartment,
    isLoading,
    setLoading,
    error,
    setError,
    setSelectedDepartment,
    setIsDepartmentsLoaded,
  } = useEnterpriseStore()

  const { refetchAll } = useRoomViewStore()

  const { before, after } = useDateRange()
  const { setNotifications } = useNotificationActions()

  const { refetch: refetchProcedures } = useGetProceduresQuery({
    skip: true,
  })

  const [
    setUserDepartment,
    { loading: setUserDepartmentLoading, error: setUserDepartmentError },
  ] = useSetUserDepartment()

  useEffect(() => {
    setLoading(setUserDepartmentLoading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUserDepartmentLoading])

  useEffect(() => {
    setError(setUserDepartmentError?.message || null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUserDepartmentError])

  const location = useLocation()

  useEffect(() => {
    setSelectedDepartment(selectedDepartment || null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment])

  const handleDepartmentChange = (departmentId: number) => {
    const selectedDept = departments.find((dept) => dept.id === departmentId)
    setSelectedDepartment(selectedDept || null)
    setIsDepartmentsLoaded(false)
    setUserDepartment({
      variables: {
        input: {
          departmentId,
        },
      },
    }).then(() => {
      refetchProcedures({
        startDate: after,
        endDate: before,
        pendingOnly: true,
      }).then((res) => {
        setNotifications(loadNotifications(res?.data))
      })
      if (location.pathname === '/rooms') {
        refetchAll()
      } else if (
        location.pathname === '/location-management' ||
        location.pathname === '/catalog'
      ) {
        window.location.reload()
      }
      // Always set loading to false and departments loaded to true after department change
      setLoading(false)
      setIsDepartmentsLoaded(true)
    })
  }

  return {
    handleDepartmentChange,
    isLoading,
    error,
    departments,
    selectedDepartment,
  }
}
